import React, { useEffect, useState } from "react";  
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../../environment/BackendService";  
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";  
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";
  
const useCouponPatientPayGPIList = () => {  
    const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);  
  const [paramsData, setParamsData] = useState({  
    cpfGpiListName: "",  
  });  
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [rowData, setRowData] = useState("");  
  const [currentPage, setCurrentPage] = useState(0);  
  const [selectedRows, setSelectedRows] = useState([]);  
  const navigateToPage = useCustomNavigate();  
  const [dropdownValues, setDropdownValues] = useState({});  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [selectedOption, setSelectedOption] = useState("no");  
  const toast = useToast();  
  const location = useLocation();  
  const { ADD_COUPON_PATIENT_PAY_GPI_LIST, DISPLAY_COUPON_PATIENT_PAY_GPI_LIST, GPIS_COUPON_PATIENT_PAY_GPI_LIST } = ROUTE_PATHS;  
  
  const screen_title = "Coupon Patient Pay GPI List";  
  const screenNumber = "RCCPF004";  
  
  const formFields = [  
    {  
      fieldLabel: "CPF GPI List Name",  
      name: "searchCriteria",  
      label: "List",  
      type: "text",  
      fieldNature: "editable",  
      value: "",  
      maxLength: 10,  
    },  
  ];  
  
  const dropdownOptions = [];  
  
  const ctaButtons = [  
   
  ];  
  const leftButtons = [  
    {  
      button_label: "Back",  
      button_handeler: () => {  
        navigateToPage("Back");  
      },  
      button_key: "F12",  
    }
  ];  
  
  const menuOptions = [  
    {  
      label: "Select",  
      icon: <span className="material-icons">select</span>,  
      command: () => {  
        navigateToPage(ADD_COUPON_PATIENT_PAY_GPI_LIST, {  
          selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.cpfGpiListName],  
          previousScreen: location.pathname,  
        });  
      },  
    },  
    {  
      label: "Display",  
      icon: <span className="material-icons">display</span>,  
      command: () => {  
        navigateToPage(DISPLAY_COUPON_PATIENT_PAY_GPI_LIST, {  
          selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.cpfGpiListName],  
          previousScreen: location.pathname,  
        });  
      },  
    },  
    {  
      label: "GPIs",  
      icon: <span className="material-icons">gpis</span>,  
      command: () => {  
        navigateToPage(GPIS_COUPON_PATIENT_PAY_GPI_LIST, {  
          selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.cpfGpiListName],  
          previousScreen: location.pathname,  
        });  
      },  
    },  
  ];  
  
  const columnDef = [  
    {  
      header: "List",  
      field: "list",  
    },  
    {  
      header: "Description",  
      field: "description",  
    },  
  ];  
  
  const parmKey = "cpfGpiListName";  
  
  const fetchData = async () => {  
    const page = first / rows;  
    try {  
      const raw_response = await axios_helper_no_header(  
        "GET",  
        `api/couponPatientPayGPIList`,  
        null,  
        {  
          page: page,  
          size: rows,  
          ...paramsData,  
        }  
      );  
      const response = raw_response.responseData;  
      const pageResponse = raw_response.responsePaginationDTO;  
      if (response.length === 0) {  
        setData([]);  
        setTotalRecords(0);  
        toast.current.show({  
          severity: "info",  
          summary: "",  
          detail: response.responseStatus.message,  
          life: 3000,  
        });  
      } else {  
        setData(response);  
        setTotalRecords(pageResponse.totalRecords);  
      }  
    } catch (error) {  
      console.error("Error fetching data:", error);  
      setData([]);  
      setTotalRecords(0);  
    }  
  };  
  
  const fetchDropdownData = async (dataDropdown) => {  
    try {  
      const response = await fetchDropdownValues(dataDropdown);  
      setDropdownValues(response);  
    } catch (error) {  
      console.error("Error fetching dropdown values:", error);  
    }  
  };  
  

  
  useEffect(() => {  
    fetchData();  
  }, [paramsData, rows, currentPage]);  
  
  const onPageChange = (event) => {  
    setFirst(event.first);  
    setCurrentPage(event.page);  
    setRows(event.rows);  
  };  
  
  const openConfirmationModal = () => {  
    setIsConfirmationModalOpen(true);  
  };  
  
  const closeConfirmationModal = () => {  
    setIsConfirmationModalOpen(false);  
    setSelectedOption("no");  
  };  
  
  const deletePriceSchedule = () => {  
    if (selectedOption === "yes") {  
      const params = { cpfGpiListName: rowData[parmKey] };  
      axios_helper_no_header("DELETE", "api/couponpatientpaygpi", null, params)  
        .then((response) => {  
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);  
          setTotalRecords((prevTotal) => prevTotal - 1);  
          setData(updatedItems);  
          toast.current.show({  
            severity: "success",  
            summary: "",  
            detail: response.responseStatus.message,  
            life: 3000,  
          });  
          closeConfirmationModal();  
        })  
        .catch((error) => {  
          console.error("There was an error deleting the data!", error);  
          toast.current.show({  
            severity: "error",  
            summary: "",  
            detail: error.message,  
            life: 3000,  
          });  
          closeConfirmationModal();  
        });  
    } else {  
      closeConfirmationModal();  
    }  
  };  

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/couponpatientpaygpi/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };
  
  const updateParamData = (data) => {  
    setFirst(0);  
    setCurrentPage(0);  
    setParamsData(data);  
  };  
  
  return {  
    screenNumber,  
    screen_title,  
    formFields,  
    dropdownValues,  
    paramsData,  
    updateParamData,  
    ctaButtons,  
    leftButtons,
    data,  
    parmKey,  
    menuOptions,  
    columnDef,  
    setRowData,  
    selectedRows,  
    setSelectedRows,  
    first,  
    rows,  
    totalRecords,  
    currentPage,  
    onPageChange,  
    isConfirmationModalOpen,  
    closeConfirmationModal,  
    deletePriceSchedule,  
    setSelectedOption,  
  };  
};  

export default useCouponPatientPayGPIList;